
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[id]",
      function () {
        return require("private-next-pages/page/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/[id]"])
      });
    }
  